"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = void 0;
// {file:
// {
//     data: RNFetchBlob.wrap(image.path.replace('file:///', '')),
//         imageType: image.mime,
//             filename: 'avatar.' + image.mime.replace('image/', ''),
//                 name: 'avatar',
//                     type: image.mime
// }}
var File = /** @class */ (function () {
    function File() {
    }
    return File;
}());
exports.File = File;
//# sourceMappingURL=file.js.map